<template>
    <div class="search-bar" v-show="hideSearchBar">
        <div :class="`input-bar __mobile`" v-show="showSearchBar">
            <form action="/search/" class="form-container">
                <input
                    name="q"
                    placeholder="Search"
                    type="search"
                    autocomplete="off"
                    class="search-input"
                />
                <button type="submit" class="button no-border-radius">
                    <SearchIcon />
                </button>
            </form>
        </div>

        <div class="button" @click="toggleSearchBar()">
            <SearchIcon v-if="!showSearchBar" />
            <span class="close-btn" v-else>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-x-icon lucide-x"
                >
                    <path d="M18 6 6 18" />
                    <path d="m6 6 12 12" />
                </svg>
            </span>
        </div>
    </div>
</template>

<script>
import SearchIcon from './SearchIcon';
import { mediaQueriesMixin } from '@/mixins';
export default {
    name: 'SearchBar',
    components: {
        SearchIcon,
    },
    mixins: [mediaQueriesMixin],
    data() {
        return {
            showSearchBar: false,
        };
    },
    computed: {
        hideSearchBar() {
            if (window.__host__.ghost_writer_articles) {
                return window.__host__.ghost_writer_articles;
            }

            let category = this.$route.params.category;
            if (this.$route.name === 'home') category = 'default';
            if (!category) return true;

            category =
                this.$globalConstants.host['category_seo_tags'][category];

            if (!category) return true;

            return Boolean(category && category['show_adsense_games']);
        },
    },
    methods: {
        toggleSearchBar() {
            if (this.isMobileDevice()) {
                this.showSearchBar = !this.showSearchBar;
            } else {
                this.$emit('toggleMenuItems', true);
                this.showSearchBar = !this.showSearchBar;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';

.search-bar {
    display: flex;
    margin-left: 20px;
    grid-column-gap: 20px;
    width: fit-content;
    .button {
        background: white;
        width: 32px;
        height: 32px;
        min-width: 32px;
        min-height: 32px;
        display: flex;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
        border-radius: 50%;
        cursor: pointer;
        align-items: center;
        justify-content: center;

        .close-btn {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .input-bar.__mobile {
        position: absolute;
        top: 55px;
        height: 32px;
        right: 10px;
        left: 10px;
        width: calc(100% - 20px) !important;
    }

    .no-border-radius {
        border-radius: 0px;
    }

    .search-input {
        padding: 5px;
        max-width: 180px;
        font-size: 14px;
    }
    .form-container {
        display: flex;
        gap: 5px;
        justify-content: end;
        width: 100%;
    }
}
</style>
